<template>
  <div class="header">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand class="d-none d-sm-block" href="#">{{$session.get('app_name')}}</b-navbar-brand>
      <b-navbar-brand class="d-block d-sm-none" href="#">{{$session.get('app_name_sm')}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <!--<b-nav-item href="#">Link</b-nav-item>-->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item :href="$root.getDashboardLink()">Home</b-nav-item>
          <b-nav-item href="/control/" v-if="$root.chkperm('page_control','enabled')">Control</b-nav-item>
          <b-nav-item href="/complaints/" v-if="$root.chkperm('page_complaint','enabled')">Complaints</b-nav-item>
          <b-nav-item-dropdown text="Settings" v-if="$root.chkperm('page_zones','enabled') || $root.chkperm('page_users','enabled')" right>
            <b-dropdown-item href="/ulbs" v-if="$root.chkperm('page_ulbs','enabled')">Manage ULB</b-dropdown-item>
            <b-dropdown-item href="/cities" v-if="$root.chkperm('page_cities','enabled')">Manage Cities</b-dropdown-item>
            <b-dropdown-item href="/zones" v-if="$root.chkperm('page_zones','enabled')">Manage Zones</b-dropdown-item>
            <b-dropdown-item href="/wards" v-if="$root.chkperm('page_wards','enabled')">Manage Wards</b-dropdown-item>
            <b-dropdown-item href="/users" v-if="$root.chkperm('page_users','enabled')">Manage Users</b-dropdown-item>
            <b-dropdown-item href="/corrections" v-if="$root.chkperm('corrections','enabled')">Corrections</b-dropdown-item>
            <b-dropdown-item href="/master-devices" v-if="$root.chkperm('master_devices','enabled')">Master Devices</b-dropdown-item>
            <b-dropdown-item href="/unregistered" v-if="$root.chkperm('unregistered','enabled')">Unregistered Devices</b-dropdown-item>
            <b-dropdown-item href="/pushdata" >Push Data</b-dropdown-item>
            <b-dropdown-item href="/ccms-testing">CCMS Testing</b-dropdown-item>
            <b-dropdown-item href="/replace-devices" >Replace Device</b-dropdown-item>
            <b-dropdown-item href="/rtc-mismatch" >RTC Mismatch</b-dropdown-item>
          </b-nav-item-dropdown>
          <!--<b-nav-item href="/find-device/" v-if="$root.chkperm('find_device','enabled')">Search</b-nav-item>-->
          <b-nav-item href="/live-tracking/" v-if="$root.chkperm('tracking','live')">Tracking</b-nav-item>
          <b-nav-item v-if="$root.chkperm('find_device','enabled')" @click="$root.search_sidebar = true">Search</b-nav-item>
          <b-nav-item href="/maintenance/" v-if="$root.chkperm('maintenance','enabled')">Maintenance</b-nav-item>
          <b-nav-item-dropdown text="Reports" v-if="$root.chkperm('ulb_reports','enabled') || $root.chkperm('device_reports','enabled')" right>
            <b-dropdown-item href="/device-reports" v-if="$root.chkperm('ulb_reports','enabled')">Download Report</b-dropdown-item>
            <b-dropdown-item href="/device-report">Device Report</b-dropdown-item>
            <b-dropdown-item href="/ulb-report">ULB Report</b-dropdown-item>
            <b-dropdown-item href="/reports/overvoltage">Overvoltage Report</b-dropdown-item>
            <b-dropdown-item href="/reports/overload">Overload Report</b-dropdown-item>
            <b-dropdown-item href="/reports/analysis">Analysis Report</b-dropdown-item>
            <b-dropdown-item href="/consumption" >Daily Consumption</b-dropdown-item>
            <b-dropdown-item href="/monthlyconsumption" >Monthly Consumption</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>{{$session.get('user_info').username}}</em>
            </template>
            <b-dropdown-item href="#" v-b-modal="'password-modal'" v-if="$root.chkperm('change_password','enabled')">Change Password</b-dropdown-item>
            <b-dropdown-item href="/logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
      <b-modal id="password-modal" title="Change Password" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
            <b-form-input v-model="current_password" type="password"  required></b-form-input>
          </b-form-group>
          <b-form-group label="New Password" label-cols="4" label-size="sm" label-align-sm="right">
            <b-form-input v-model="new_password" type="password" :state="passwordState" required></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 4 letters
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
        <template v-slot:modal-footer="{ ok, close }">
          <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
          <b-button size="sm" variant="success" @click="ok()">Update</b-button>
        </template>
      </b-modal>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
      current_password: '', 
      new_password: '',
      passwordUrl: this.$session.get('apiurl')+'api/change-password',
    }
  },
  methods:{
    resetSelectedItem(){
      this.current_password = '';
      this.new_password = '';
    },
    modalSubmit(bvModalEvt){
      var self = this;
      //self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = self.passwordUrl;

      var o = {'cp': this.current_password, 'np': this.new_password};

      self.axios.post(submitUrl, {
        accesskey: self.$session.get('access_key'),
        data: o
      })
      .then(function (response) {
        if(response.data.error == 0 || response.data.error == '0'){
          self.$bvModal.hide('my-modal');
          self.$bvToast.toast(response.data.message, {
            title: 'Status',
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 5000,
            variant: 'warning',
            solid: true,
            appendToast: true
          });
        }
        
      })
      .catch(function (error) {
        alert(error);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.header{
  position: fixed;
  top:0px;
  width: 100%;
  z-index: 10;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}


</style>
